import React from "react";
import { ForgotPassword } from "../containers";

export default function ForgotPasswordPage() {
    return <ForgotPassword />;
}